import { FeatureFlagsProvider } from '@eventbrite/feature-flag-utils';
import React from 'react';
import {
    BrowserRouter,
    MemoryRouter,
    Route,
    StaticRouter,
    Switch,
} from 'react-router-dom';
import { CreateEventScreen, PreviewScreen } from './screens';
import {
    AppProps,
    AppRouteProps,
    BASE_PATH,
    GlobalStyles,
    IAuthProps,
    Layout,
    RouteWithPropsProps,
} from './shared';

const RouteWithProps = ({
    component: Component,
    componentProps,
    path,
}: RouteWithPropsProps) => {
    return (
        <Route
            path={path}
            render={(routeProps: AppRouteProps) => (
                <Component {...routeProps} {...componentProps} />
            )}
        />
    );
};

export const App: React.FC<AppProps & IAuthProps> = (props) => {
    const isClient = typeof window !== 'undefined';

    const Router: typeof BrowserRouter | StaticRouter | MemoryRouter =
        props.testPath ? MemoryRouter : isClient ? BrowserRouter : StaticRouter;

    const locationProp: {
        location?: string;
    } = {
        location: props.request?.path,
    };

    const testProps = props.testPath
        ? { initialEntries: [props.testPath] }
        : {};

    // prevent blowing up if we're on the server
    if (!isClient) {
        return null;
    }

    return (
        <>
            <FeatureFlagsProvider value={props.featureFlags || {}}>
                <GlobalStyles />
                <Layout>
                    <Router
                        {...locationProp}
                        {...testProps}
                        basename={BASE_PATH}
                    >
                        <Switch>
                            <RouteWithProps
                                path={'/preview'}
                                component={PreviewScreen}
                                componentProps={props}
                            />
                            <RouteWithProps
                                path={'/'}
                                component={CreateEventScreen}
                                componentProps={props}
                            />
                        </Switch>
                    </Router>
                </Layout>
            </FeatureFlagsProvider>
        </>
    );
};
